import GameObject from '../../GameObject/GameObject';
import { Tween, Group } from '@tweenjs/tween.js';
import EventEmitter from 'eventemitter3';
import Game from '../../Game';

export enum AnimationClipEvent {
    START = 'start_animation_clip',
    UPDATE = 'update_animation_clip',
    COMPLETE = 'animation_clip_complete',
    DESTROY = 'destroy_animation_clip',
}

export default class AnimationClip<T = any> extends EventEmitter {
    public gameObject: GameObject;
    public meta: T;

    public iterator: Iterator<number>;
    public result: IteratorResult<number>;

    private readonly tweenGroup: Group;
    public elapsedTime: number;
    public timeScale: number = 1;
    /** Set to true to prevent cancelling current animation */
    public additive: boolean;

    constructor(gameObject: GameObject, meta?: T, additive: boolean = false) {
        super();
        this.gameObject = gameObject;
        this.meta = meta;
        this.tweenGroup = new Group();
        this.elapsedTime = 0;
        this.additive = additive;
    }

    public getTween(target: any) {
        return new Tween(target, this.tweenGroup);
    }

    public *startTween(tween: Tween): IterableIterator<number> {
        tween.start(this.elapsedTime);
        // @ts-ignore
        while (tween.isPlaying()) yield;
    }

    public start() {
        this.elapsedTime = 0;
        this.iterator = this.execute(this.gameObject, this.meta);
        this.result = this.iterator.next();
        this.emit(AnimationClipEvent.START, this);
    }

    public *execute(
        gameObject: GameObject,
        meta?: T
    ): IterableIterator<number> {}

    public update(): void {
        const delta = Game.ticker.getDeltaTime();
        this.elapsedTime += delta * this.timeScale;
        try {
            this.tweenGroup.update(this.elapsedTime);
            //.getAll()
            //.forEach(tween => tween.update(this.elapsedTime));
            this.result = this.iterator.next(
                // @ts-ignore
                delta
            );
            this.emit(AnimationClipEvent.UPDATE, this);
            if (this.result.done) {
                this.complete();
            }
        } catch (e) {
            console.error(e); // when this happens animation is not completed, and for ex. some card may stay hidden
            this.complete();
        }
    }

    public destroy() {
        this.emit(AnimationClipEvent.DESTROY, this);
        this.removeAllListeners();
        this.tweenGroup.getAll().forEach(tween => tween.stop());
    }

    public complete(): void {
        this.emit(AnimationClipEvent.COMPLETE, this);
    }
}
